module.exports = {"210411002":"长春街道","210411003":"葛布街道","210411004":"将军堡街道","210411005":"新华街道","210411007":"抚顺城街道","210411102":"前甸镇","210411201":"河北乡","210411205":"会元乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210411.json
// module id = 623
// module chunks = 0